import { render, staticRenderFns } from "./AwsOppRegistration.vue?vue&type=template&id=0f9ca1d8&scoped=true&"
import script from "./AwsOppRegistration.vue?vue&type=script&lang=js&"
export * from "./AwsOppRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AwsOppRegistration.vue?vue&type=style&index=0&id=0f9ca1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ca1d8",
  null
  
)

export default component.exports